<script lang="ts" setup>
import type { FormResult } from '~kui/types/formResult';

import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';

const props = withDefaults(defineProps<FormResult>(), {
  dismissable: true,
});

defineEmits<{
  clear: [];
}>();

const variantClasses = computed<string>(() =>
  twMerge(
    cva('flex items-center justify-between space-x-3 rounded-xl border bg-white p-3', {
      variants: {
        variant: {
          success: 'border-success text-success-foreground',
          info: 'border-brand-blue text-foreground',
          error: 'border-destructive text-destructive',
          warning: 'border-brand-yellow bg-brand-yellow-subtle',
        },
      },
    })({
      variant: props.variant,
    }),
  ),
);
const iconClasses = computed<string>(() =>
  twMerge(
    cva('', {
      variants: {
        variant: {
          success: '',
          info: '',
          error: '',
          warning: 'text-foreground',
        },
      },
    })({
      variant: props.variant,
    }),
  ),
);
</script>

<template>
  <div
    role="alert"
    aria-live="assertive"
    :data-testid="`kui-alert-message-${variant}`"
    :class="variantClasses"
  >
    <div class="flex items-center space-x-3">
      <Icon
        :name="ICONS.information"
        size="lg"
        :class="iconClasses"
      />
      <div class="flex">
        <span class="sr-only">Alert:</span>
        <KUICoreHtml :html="message || ''" />
      </div>
      <slot name="actionButtons" />
    </div>
    <button
      v-if="dismissable"
      type="button"
      class="text-foreground flex size-4 items-center"
      aria-label="close alert"
      @click="$emit('clear')"
    >
      <Icon :name="ICONS.cancel" size="xs" />
    </button>
  </div>
</template>
